function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.175 15.8749C10.5583 16.2582 11.1125 16.4374 11.8375 16.4124C12.5625 16.3874 13.0917 16.1166 13.425 15.5999L18.825 7.1249L10.45 12.5999C9.95 12.9332 9.68333 13.4666 9.65 14.1999C9.61667 14.9332 9.79167 15.4916 10.175 15.8749V15.8749ZM11.95 4.0249C12.9 4.0249 13.8917 4.17907 14.925 4.4874C15.9583 4.79574 16.95 5.3249 17.9 6.0749L16.6 6.9999C15.85 6.4999 15.0458 6.12907 14.1875 5.8874C13.3292 5.64574 12.5833 5.5249 11.95 5.5249C9.61667 5.5249 7.625 6.35824 5.975 8.0249C4.325 9.69157 3.5 11.7166 3.5 14.0999C3.5 14.8499 3.60417 15.6082 3.8125 16.3749C4.02083 17.1416 4.31667 17.8499 4.7 18.4999H19.175C19.5417 17.8999 19.8333 17.1999 20.05 16.3999C20.2667 15.5999 20.375 14.8166 20.375 14.0499C20.375 13.3499 20.2708 12.5957 20.0625 11.7874C19.8542 10.9791 19.4833 10.2332 18.95 9.5499L19.925 8.2499C20.5583 9.18324 21.0333 10.1207 21.35 11.0624C21.6667 12.0041 21.8417 12.9499 21.875 13.8999C21.9083 14.8999 21.8083 15.8416 21.575 16.7249C21.3417 17.6082 21 18.4249 20.55 19.1749C20.35 19.5582 20.1375 19.7916 19.9125 19.8749C19.6875 19.9582 19.4083 19.9999 19.075 19.9999H4.8C4.51667 19.9999 4.2375 19.9291 3.9625 19.7874C3.6875 19.6457 3.48333 19.4416 3.35 19.1749C2.91667 18.3749 2.58333 17.5624 2.35 16.7374C2.11667 15.9124 2 15.0332 2 14.0999C2 12.7166 2.2625 11.4124 2.7875 10.1874C3.3125 8.9624 4.025 7.89574 4.925 6.9874C5.825 6.07907 6.87917 5.35824 8.0875 4.8249C9.29583 4.29157 10.5833 4.0249 11.95 4.0249V4.0249Z",
  fill: "black"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/speed.8b3e61c6.svg";
export { SvgComponent as ReactComponent };